import { useMemo } from 'react';

import { AppointmentView } from '@dreryk/egabinet-dashboard-frontend-api';

import { LineChart } from '@dreryk/react-charts';
import { useTranslate } from '@dreryk/react-common';

import { dashboardTranslationKeys } from '../../../translations';
import { TooltipCard } from '../shared/TooltipCard';

import { StyledRegisteredAppointmentsChart } from './RegisteredAppointmentsChart.styled';
import { mapAppointmentsToChartData } from './RegisteredAppointmentsChart.utils';

type RegisteredAppointmentsChartProps = {
   readonly appointmentsView: AppointmentView[];
};

export const RegisteredAppointmentsChart = (props: RegisteredAppointmentsChartProps): JSX.Element => {
   const translate = useTranslate();
   const data = useMemo(() => {
      return mapAppointmentsToChartData(props.appointmentsView, translate);
   }, [props.appointmentsView, translate]);

   return (
      <StyledRegisteredAppointmentsChart>
         <LineChart
            stackSeriesIndex={1}
            data={data}
            tooltip={(slice) => <TooltipCard data={slice} label={dashboardTranslationKeys.cards.registeredCount} />}
         />
      </StyledRegisteredAppointmentsChart>
   );
};
